module.exports = __webpack_public_path__ + "img/test.f8d9651e.svg";